import { Layers, Candy, Wand2, Palette, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { TECNICHE_CARDS, LINKS } from "@/data/content";

const ICONS = { Layers, Candy, Wand2, Palette };

const HotmartCta = ({ testid, small }) => (
  <a
    data-testid={testid}
    href={LINKS.hotmart}
    target="_blank"
    rel="noopener noreferrer"
    className={`group inline-flex items-center gap-1.5 rounded-full font-bold transition-colors ${
      small
        ? "mt-4 text-xs text-hotmart hover:text-hotmart-dark"
        : "bg-hotmart px-7 py-3.5 text-sm text-white shadow-[0_12px_35px_rgba(230,81,0,0.35)] hover:bg-hotmart-dark"
    }`}
  >
    Scopri il Corso Completo
    <ArrowUpRight className={`${small ? "h-3.5 w-3.5" : "h-4 w-4"} transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5`} />
  </a>
);

const Tecniche = () => (
  <div data-testid="section-tecniche" className="mx-auto max-w-md px-5 pb-10 pt-14 sm:max-w-2xl sm:pt-20 lg:max-w-5xl lg:px-8">
    <Reveal>
      <Eyebrow>Anteprima del Corso</Eyebrow>
      <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-cacao sm:text-5xl">
        Materiali & Tecniche
      </h1>
      <p className="mt-3 max-w-lg text-base text-cacao-muted leading-relaxed">
        La guida essenziale agli strumenti del cake designer: cosa serve
        davvero per foderare, modellare e colorare come una professionista.
      </p>
    </Reveal>

    <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {TECNICHE_CARDS.map((card, i) => {
        const Icon = ICONS[card.icon];
        return (
          <Reveal key={card.title} delay={i * 0.06}>
            <article
              data-testid={`tecnica-card-${i + 1}`}
              className="flex h-full flex-col rounded-3xl border border-pink-100 bg-white p-6 transition-all hover:-translate-y-1 hover:shadow-[0_18px_45px_rgba(45,36,36,0.1)]"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-blush">
                <Icon className="h-5 w-5 text-rosa-dark" />
              </div>
              <h3 className="mt-4 font-display text-lg font-bold text-cacao">{card.title}</h3>
              <p className="mt-1.5 flex-1 text-sm text-cacao-muted leading-relaxed">{card.text}</p>
              <HotmartCta testid={`hotmart-cta-tecnica-${i + 1}`} small />
            </article>
          </Reveal>
        );
      })}
    </div>
  </div>
);

export default Tecniche;
